import { isArray } from 'lodash';
import FilterRangeService from 'inventory-listing/components/ListingFilters/Components/FilterRange/FilterRangeService/FilterRangeService.js';
import {
    URL_PARAMETER_MIN,
    URL_PARAMETER_MAX,
} from 'inventory-listing/components/ListingFilters/Components/ListingFiltersYears/ListingFiltersYearsRange/constants.js';
import { UrlService } from '@sm360/widget-commons-core-services';

class ListingFiltersYearsButtonsService {
    getSelectedValues(models) {
        let selectedMin = null;
        let selectedMax = null;

        if (isArray(models)) {
            models.forEach((model) => {
                if (model.isSelected) {
                    const modelNumber = Number.parseInt(model.label, 10);
                    if (!selectedMin || modelNumber <= selectedMin) {
                        selectedMin = modelNumber;
                    }

                    if (!selectedMax || modelNumber >= selectedMax) {
                        selectedMax = modelNumber;
                    }
                }
            });
        }

        return {
            selectedMin,
            selectedMax,
        };
    }

    getInitModels(models, contextYear) {
        let { urlMin, urlMax } = FilterRangeService.getUrlValues(URL_PARAMETER_MIN, URL_PARAMETER_MAX);
        if (contextYear && UrlService.containsPath(contextYear)) {
            urlMin = contextYear;
            urlMax = contextYear;
        }

        return (
            isArray(models) &&
            models.map((model) => {
                const modelNumber = Number.parseInt(model.label, 10);
                if (modelNumber === urlMin || modelNumber === urlMax) {
                    return model.set('isSelected', true);
                }
                return model;
            })
        );
    }

    resetAllModels(models) {
        return models.map((model) => model.set('isSelected', false));
    }

    toggleModel(models, modelNumber) {
        return (
            isArray(models) &&
            models.map((model) => {
                if (model.get('label') === String(modelNumber)) {
                    return model.set('isSelected', !model.isSelected);
                }
                return model;
            })
        );
    }
}

export default new ListingFiltersYearsButtonsService();
